export default {"src":"/_next/static/media/triangles.5de777a8.svg","height":52,"width":17};